import React from "react";
import { useLang } from "../i18n";
import { Linkedin, Mail, ArrowUp } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-gt-cream/10" style={{ backgroundColor: "#071614" }}>
      <div className="gt-grain absolute inset-0" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <a href="#top" className="block group mb-8" data-testid="footer-logo">
              <img
                src="/brand/logo-gt-slogan.svg"
                alt="GT Strategy — Evoluímos negócios, transformamos culturas."
                className="h-32 md:h-40 lg:h-44 w-auto opacity-90 group-hover:opacity-100 transition-opacity"
                style={{ filter: "brightness(1.15)" }}
              />
            </a>
            <p className="text-xs uppercase tracking-[0.22em] text-gt-mute">{t.footer.since}</p>
            <p className="mt-5 text-sm md:text-base text-gt-ink/70 max-w-md leading-relaxed">
              {t.footer.desc}
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[0.65rem] uppercase tracking-[0.25em] text-gt-cream/80 mb-5">{t.footer.sections.explore}</div>
            <ul className="space-y-3 text-sm text-gt-ink/75">
              <li><a href="#method" className="hover:text-gt-cream transition-colors">{t.nav.method}</a></li>
              <li><a href="#services" className="hover:text-gt-cream transition-colors">{t.nav.services}</a></li>
              <li><a href="#cases" className="hover:text-gt-cream transition-colors">{t.nav.cases}</a></li>
              <li><a href="#clients" className="hover:text-gt-cream transition-colors">{t.nav.clients}</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[0.65rem] uppercase tracking-[0.25em] text-gt-cream/80 mb-5">{t.footer.sections.contact}</div>
            <ul className="space-y-4 text-sm text-gt-ink/80">
              <li>
                <a href="mailto:contato@gtstrategy.com.br" data-testid="footer-email" className="inline-flex items-center gap-3 hover:text-gt-cream transition-colors">
                  <Mail size={16} /> contato@gtstrategy.com.br
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/gtstrategy/" target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="inline-flex items-center gap-3 hover:text-gt-cream transition-colors">
                  <Linkedin size={16} /> /company/gtstrategy
                </a>
              </li>
              <li className="pt-4">
                <a href="#top" data-testid="back-to-top" className="inline-flex items-center gap-2 text-gt-cream/70 hover:text-gt-cream text-xs uppercase tracking-[0.2em]">
                  <ArrowUp size={14} /> {t.footer.back_to_top}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gt-cream/10 pt-6 mt-14 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="text-xs text-gt-mute">© {year} GT Strategy. {t.footer.rights}</div>
          <div className="text-xs text-gt-mute">Evolution by Design.</div>
        </div>
      </div>
    </footer>
  );
}
